import campaigns from "./sections/apiCampaign";
import auth from "./sections/apiAuth";
import companies from "./sections/apiCompanies";

const dataApi = {
  campaigns,
  auth,
  companies
};

export default dataApi;
